//@ts-nocheck
import React, { useState } from 'react';
import { Tabs, Tab } from "react-bootstrap";
import Allpnrbooking from './Allpnrbooking';
import { bookingStatus,searchApiOrgId ,bookingStatusForTab } from "../bookingConfirmation/Utils/Constant"
import { useDispatch } from "react-redux";
import { getMyFiles } from "../bookingConfirmation/thunks/getMyFiles"
import { useEffect } from 'react';
import { useSelector } from "react-redux";
import { endTimeDate } from "../bookingConfirmation/Utils/CommenFunction"
import { setResultFlag } from '../bookingConfirmation/ActionCreator/flightBooking';
import { resetMyFilesFilters } from '../bookingConfirmation/ActionCreator/myFiles';

export default function Bookingpnrlist(props) {
  let { myFilesData, initialResult, initialPayload } = props;
  const dispatch = useDispatch();
  const [myFiles, setMyFiles] = useState([])
  const [key, setKey] = useState("All");
  const [isResult,setResult] =useState(props.isResult)
  const[isLoading,setIsLoading] = useState(false)
  const [nextResultKeyArray, setNextResultKeyArray] = useState(["start"])
  const [nextResultKeyCounter, setNextResultKeyCounter] = useState(0)
  const [initialPayloadLocal, setIinitialPayloadLocal] = useState(initialPayload)
  const [endOfNextKey, setEndOfNextKey] = useState(false)  
  const [customDateChanged, setCustomDateChanged] = useState(false)
  const [selectedProvider, setSelectedProvider] = useState({code:"", description:"All Bookings"})

  const orgId = useSelector((state) => state.agentProfile.orgId);
  const agencyId = useSelector((state) => state.agentProfile.agencyId);
  const agencyGroupId = useSelector((state) => state.agentProfile.agencyGroupId);    
  const reduxMyFiles = useSelector((state) => state.myFile.myFilesData);  
  const isTimeoutErrorFlag = useSelector((state) => state.myFileError.myFilesDataError);
  const agentName = useSelector((state) => state.agentProfile.agentName);
  const agentInfo = useSelector((state) => state.agentProfile.agentDetails);
  const agencyDetails = useSelector((state) => state.agentProfile.agencyDetails);
  const isInternalUserAutheticated = useSelector((state) => state.internalUser.isInternalUserAutheticated);
  const agencyField = useSelector((state) => state.searchForm.agencyField)
  let backupOrgId = localStorage.getItem("orgId");

 

  useEffect(()=>{
    if(reduxMyFiles?.length > 0 || !isTimeoutErrorFlag){
      if (isLoading) { setIsLoading(false) }
      if(reduxMyFiles?.length == 0 && !isTimeoutErrorFlag){
        setNextResultKeyCounter(0)
      }
    }
  },[reduxMyFiles, isTimeoutErrorFlag])

 useEffect(()=>{
  setIinitialPayloadLocal(initialPayload)
 },[initialPayload])

  useEffect(() => {
    let filteredStatusrr =["BA","UKN","BF"]
      let filterListData = myFilesData && myFilesData.filter(pnrData => ((!filteredStatusrr.includes(pnrData?.bookingStatusCodeSearchText))))
    setMyFiles(filterListData)
    setCustomDateChanged(false)
  }, [myFilesData])

  useEffect(() => {
    setResult(props.isResult)
  }, [props.isResult])

  useEffect(()=>{
    if(initialResult && initialResult?.nextResultKey && initialPayload){
      setNextResultKeyCounter(0)
      setEndOfNextKey(false)
      setNextResultKeyArray(["start",initialResult?.nextResultKey])
    }
    if(!initialResult?.nextResultKey){
      setEndOfNextKey(true)
    }
  },[initialResult,initialPayload])

  useEffect(()=>{
    setCustomDateChanged(true);
    setKey("All");
    if(props.bookingStatusCode) props.bookingStatusCode("All")
    setMyFiles([])
  },[props.date])


  const getFilterByStatus = async (k) => {
    setResult(false)
    setIsLoading(true)
    setKey(k)
    props.bookingStatusCode(k)
    setSelectedProvider({code:"", description:"All Bookings"})
    let requestPayload = {}
    let from = props.filterOption +"FromDate"
    let to = props.filterOption +"ToDate"
    dispatch(resetMyFilesFilters(true));
    
    if (k === "All") {
      requestPayload = {
        organizationId: orgId !== "" ? orgId : backupOrgId,
        agencyId: agencyId,
        agencyGroupId: agencyGroupId,
        [from]: props.date && props.date.from,
        [to]: props.date && props.date.to,
        agentUserName: isInternalUserAutheticated ? (agencyField?.value?.allowEdocsSharing || agencyDetails?.allowEdocsSharing) ? undefined : (agentInfo?.username || undefined) : agencyDetails?.allowEdocsSharing ? undefined : (agencyDetails?.username || undefined)

      }
    } else {
      requestPayload = {
        organizationId: orgId !== "" ? orgId : backupOrgId,
        agencyId: agencyId,
        agencyGroupId: agencyGroupId,
        bookingStatusCodes: k === "NTC" ? [k,"TC" ,"CR","PNTC"] : k === "PNP" ?  [k,"TF","PD","PM"] : [k],
        [from]: props.date && props.date.from,
        [to]: props.date && props.date.to,
        agentUserName: isInternalUserAutheticated ? (agencyField?.value?.allowEdocsSharing || agencyDetails?.allowEdocsSharing) ? undefined : (agentInfo?.username || undefined) : agencyDetails?.allowEdocsSharing ? undefined : (agencyDetails?.username || undefined)
      }
    }

    //if(!agencyFlag) return
    let myfilesResult = await dispatch(getMyFiles(requestPayload, props.isVirtuosoBookings, props.isGoldenTicketBookings))
    if (myfilesResult) {
      setIinitialPayloadLocal(requestPayload)
      if(myfilesResult?.nextResultKey){
        setNextResultKeyArray(["start",myfilesResult?.nextResultKey])
        setEndOfNextKey(false)
      }else{
        setNextResultKeyArray(["start"])
        setEndOfNextKey(true)
      }
      setNextResultKeyCounter(0)
      setResult(true)
      let filteredStatusrr =["BA","UKN","BF"]
      let filterListData = myfilesResult.bookings && myfilesResult.bookings.filter(pnrData => ((!filteredStatusrr.includes(pnrData?.bookingStatusCodeSearchText))))
      myfilesResult.bookings = filterListData
      if(props.filterOption==="departure"){
        setMyFiles(myfilesResult.bookings && myfilesResult.bookings.length === 0 ? [] : myfilesResult.bookings.sort((a, b) => { return new Date(b.departureDate) - new Date(a.departureDate) }))
      } else{
        setMyFiles(myfilesResult.bookings && myfilesResult.bookings.length === 0 ? [] : myfilesResult.bookings)
      }
    
    }
  }


  const sortData =(key,status)=>{
    if(key==="status") sortByStatus(status)
    if(key==="reservation") sortByReservation(status)
    if(key==="departure") sortByDeparture(status)
    if(key==="paxName") sortByPaxName(status)
    if(key==="agentName") sortByAgentName(status)
    if(key==="destination") sortByDestination(status)
    if(key==="pnr") sortByPnr(status)
    if(key==="carrier") sortByCarrier(status)

  }

  const bookingStatusTabData  = [
    { code: "All", description: "ALL" },
    { code: "NP", description: "ON HOLD" },
    { code: "PNP", description: "PAID" },
    { code: "PT", description: "TICKETED" },
    { code: "NTC", description: "CANCELLED" },
    { code : "CU", description : "CONTACT US" }
]

const allProviderName = [
  {code: "", description: "All Bookings" },
  {code: "Sabres", description: "All Non-NDC Bookings" },
  {code: "WEB", description: "All NDC Bookings" },
  {code: "Sabre", description: "Sabre GDS" },
  {code: "Sabre_NDC", description: "Sabre NDC" },
  {code: "Amadeus_NDC", description: "Amadeus NDC" },
  {code: "NDC", description: "Duffel" },
  {code: "HS_NDC_Aggregator", description: "HIS NDC" }
]

const nextOnClick = async() => {
  dispatch(resetMyFilesFilters(true));
  const requestPayload = initialPayloadLocal
  if(nextResultKeyArray[nextResultKeyCounter + 1] != "start"){
    requestPayload["nextResultKey"] = nextResultKeyArray[nextResultKeyCounter + 1]
    setIsLoading(true)
    const myfilesResult = await dispatch(getMyFiles(requestPayload, props.isVirtuosoBookings, props.isGoldenTicketBookings))
    if(myfilesResult){
      setNextResultKeyCounter(nextResultKeyCounter+1)
      if(myfilesResult?.nextResultKey){
        setEndOfNextKey(false)
        setNextResultKeyArray([...nextResultKeyArray,myfilesResult?.nextResultKey])
      }
      else{
        setEndOfNextKey(true)
      }
    }
    let filteredStatusrr =["BA","UKN","BF"]
    const myFilesData = myfilesResult?.bookings
    let filterListData = myFilesData && myFilesData.filter(pnrData => ((!filteredStatusrr.includes(pnrData?.bookingStatusDetail?.code)) && pnrData?.bookingDetails?.status !== "Unknown" && pnrData?.bookingStatusDetail?.status !== "PaidManually"))
    let currentProvider = selectedProvider.code;
    let newFilterListData = []
    if (currentProvider == "") {
      newFilterListData = filterListData
    } else if (currentProvider == "Sabre" || currentProvider == "Sabres") {
      newFilterListData = filterListData.filter(pnrData => (pnrData?.providerName && pnrData?.providerName.toLowerCase() == "sabre" || pnrData?.providerName.toLowerCase() == "sabre_prod"))
    } else if (currentProvider == "WEB") {
      newFilterListData = filterListData.filter(pnrData => (pnrData?.providerName && pnrData?.providerName.toLowerCase() == "sabre_ndc" || pnrData?.providerName.toLowerCase() == "amadeus_ndc" || pnrData?.providerName.toLowerCase() == "ndc" || pnrData?.providerName.toLowerCase() == "hs_ndc_aggregator"))
    } else {
      newFilterListData = filterListData.filter(pnrData => (pnrData?.providerName && pnrData?.providerName.toLowerCase() == currentProvider.toLowerCase()))
    }
    setMyFiles(newFilterListData)
  }
}

const previousOnClick = async() => {
  dispatch(resetMyFilesFilters(true));
  const requestPayload = initialPayloadLocal
  if(nextResultKeyCounter - 1 >= 0 ){
    if(nextResultKeyCounter-1 > 0){
      requestPayload["nextResultKey"] = nextResultKeyArray[nextResultKeyCounter - 1]
    }else if(requestPayload?.nextResultKey){
      delete requestPayload["nextResultKey"];
    }
    let tempArray = [...nextResultKeyArray];
    if(endOfNextKey){
      tempArray.pop();
    }else{
      tempArray.pop();
      tempArray.pop();
    }
    
    setNextResultKeyArray([...tempArray])
    setEndOfNextKey(false)
    setIsLoading(true)
    let myfilesResult = await dispatch(getMyFiles(requestPayload, props.isVirtuosoBookings, props.isGoldenTicketBookings))
    if(myfilesResult){
      setNextResultKeyCounter(nextResultKeyCounter-1)
      if(myfilesResult?.nextResultKey){
        setNextResultKeyArray([...tempArray,myfilesResult?.nextResultKey])
      }
    }
    let filteredStatusrr =["BA","UKN","BF"]
    const myFilesData = myfilesResult?.bookings
    let filterListData = myFilesData && myFilesData.filter(pnrData => ((!filteredStatusrr.includes(pnrData?.bookingStatusDetail?.code)) && pnrData?.bookingDetails?.status !== "Unknown" && pnrData?.bookingStatusDetail?.status !== "PaidManually"))
    let currentProvider = selectedProvider.code;
    let newFilterListData = []
    if (currentProvider == "") {
      newFilterListData = filterListData
    } else if (currentProvider == "Sabre" || currentProvider == "Sabres") {
      newFilterListData = filterListData.filter(pnrData => (pnrData?.providerName && pnrData?.providerName.toLowerCase() == "sabre" || pnrData?.providerName.toLowerCase() == "sabre_prod"))
    } else if (currentProvider == "WEB") {
      newFilterListData = filterListData.filter(pnrData => (pnrData?.providerName && pnrData?.providerName.toLowerCase() == "sabre_ndc" || pnrData?.providerName.toLowerCase() == "amadeus_ndc" || pnrData?.providerName.toLowerCase() == "ndc" || pnrData?.providerName.toLowerCase() == "hs_ndc_aggregator"))
    } else {
      newFilterListData = filterListData.filter(pnrData => (pnrData?.providerName && pnrData?.providerName.toLowerCase() == currentProvider.toLowerCase()))
    }
    setMyFiles(newFilterListData)
  }
}

  const handleProviderNameChange = (e) => {
    let allData = [...myFilesData];
    let selectedProvider = e.target.value;
    if (selectedProvider == "") {
      setMyFiles(allData)
    } else if (selectedProvider == "Sabre" || selectedProvider == "Sabres") {
      let filterListData = allData && allData.filter(pnrData => (pnrData?.providerName && pnrData?.providerName.toLowerCase() == "sabre" || pnrData?.providerName.toLowerCase() == "sabre_prod"))
      setMyFiles(filterListData)
    } else if (selectedProvider == "WEB") {
      let filterListData = allData && allData.filter(pnrData => (pnrData?.providerName && pnrData?.providerName.toLowerCase() == "sabre_ndc" || pnrData?.providerName.toLowerCase() == "amadeus_ndc" || pnrData?.providerName.toLowerCase() == "ndc" || pnrData?.providerName.toLowerCase() == "hs_ndc_aggregator"))
      setMyFiles(filterListData)
    } else {
      let filterListData = allData && allData.filter(pnrData => (pnrData?.providerName && pnrData?.providerName.toLowerCase() == selectedProvider.toLowerCase()))
      setMyFiles(filterListData)
    }
    setSelectedProvider(allProviderName.find(item => item.code == selectedProvider))
  }

  useEffect(() => {
    setSelectedProvider({ code: "", description: "All Bookings" })
  }, [agencyId, agentInfo?.username])

  const applyFilters = (filters) => {
    let filteredData = myFilesData;

    const hasAnyFilter = Object.values(filters).some( (val) => val && val?.trim() !== "" );


    if (!hasAnyFilter) {
      setMyFiles(myFilesData);
      return;
    }

    Object.keys(filters).forEach((key) => {
      if (!filters[key]) return;

      const value = filters[key]?.toLowerCase() || filters[key].code?.toLowerCase();

      filteredData = filteredData.filter((item) => {
        if (key === "status") {
          return item.bookingStatusDetail?.description
            ?.toLowerCase()
            .includes(value);

        } else if (key === "reservation") {
          return matchDateFilter(item.bookingDate, value);

        } else if (key === "departure") {
          return matchDateFilter(item.departureDate, value);

        } else if (key === "paxNames") {
          return item.paxNames?.toLowerCase().includes(value);

        } else if (key === "agentName") {
          return item.agentName?.toLowerCase().includes(value);

        } else if (key === "carrier") {
          return item.validatingCarrier?.toLowerCase().includes(value);

        } else if (key === "provider" && item?.providerName ) {
          
          if (value == "sabre" || value == "sabres") {
            return item?.providerName.toLowerCase() == "sabre" || item?.providerName.toLowerCase() == "sabre_prod"
          } else if (value == "web") {
            return item?.providerName.toLowerCase() == "sabre_ndc" || item?.providerName.toLowerCase() == "amadeus_ndc" || item?.providerName.toLowerCase() == "ndc" || item?.providerName.toLowerCase() == "hs_ndc_aggregator"
          } else {
            return item?.providerName.toLowerCase() == value.toLowerCase()
          }

        } else if (key === "pnr") {
          return item.pnr?.toLowerCase().includes(value) || item?.linkedPNR?.pnr?.toLowerCase().includes(value);
        }

        return true;
      });
    });

    setMyFiles(filteredData);
  };


  const normalizeDateTokens = (dateStr) => {
    if (!dateStr) return "";

    const d = new Date(dateStr);
    if (isNaN(d)) return "";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = String(d.getFullYear());

    const monthNames = d.toLocaleString("en", { month: "short" }).toLowerCase();
    const monthFull = d.toLocaleString("en", { month: "long" }).toLowerCase();

    return [
      `${day}-${month}`,
      `${day}/${month}`,
      `${day}.${month}`,
      `${day}-${month}-${year}`,
      `${day}/${month}/${year}`,
      `${day}.${month}.${year}`,
      `${day} ${monthNames}`,
      `${day}/${monthFull}`,
      `${day}-${monthFull}`,
      `${day}.${monthFull}`,
      `${day} ${monthFull} ${year}`,
      `${day}/${monthFull}/${year}`,
      `${day}-${monthFull}-${year}`,
      `${day}.${monthFull}.${year}`,
      `${day} ${monthNames} ${year}`,
      `${day}/${monthNames}/${year}`,
      `${day}-${monthNames}-${year}`,
      `${day}.${monthNames}.${year}`,
      monthNames,
      monthFull
    ].join(" ");
  };

  const matchDateFilter = (itemDate, filterValue) => {
    if (!itemDate || !filterValue) return false;
    const normalized = normalizeDateTokens(itemDate);
    return normalized.includes(filterValue.toLowerCase());
  };

  const sortByStatus =(status)=>{
    let newData
    if (status) {
      newData = myFiles && myFiles.sort((a, b) => (b?.bookingStatusCodeSearchText ? b?.bookingStatusCodeSearchText : "").localeCompare(a?.bookingStatusCodeSearchText ? a?.bookingStatusCodeSearchText : ""))
    } else {
      newData = myFiles && myFiles.sort((a, b) => (a?.bookingStatusCodeSearchText ? a?.bookingStatusCodeSearchText : "").localeCompare(b?.bookingStatusCodeSearchText ? b?.bookingStatusCodeSearchText : ""))
    }

    setMyFiles(newData)
  }

  const sortByReservation =(status)=>{
  
    let newData
    if(status){
      newData = myFiles && myFiles.sort((a, b) => 
        new Date(b.bookingDate).getTime() - 
        new Date(a.bookingDate).getTime()
        )
    } else{
      newData = myFiles && myFiles.sort((a, b) => 
        new Date(a.bookingDate).getTime() - 
        new Date(b.bookingDate).getTime())
    }

    setMyFiles(newData)
  }

  const sortByDeparture =(status)=>{
    
    let newData
    if(status){
      newData = myFiles && myFiles.sort((a, b) => 
        new Date(b.departureDate).getTime() - 
        new Date(a.departureDate).getTime()
        )
    } else{
      newData = myFiles && myFiles.sort((a, b) => 
        new Date(a.departureDate).getTime() - 
        new Date(b.departureDate).getTime())
    }
    
    setMyFiles(newData)
  }

  const sortByPaxName =(status)=>{
    let newData
    if (status) {
      newData = myFiles && myFiles.sort((a, b) => (b?.paxNames ? b?.paxNames : "").localeCompare(a?.paxNames ? a?.paxNames : ""))
    } else {
      newData = myFiles && myFiles.sort((a, b) => (a?.paxNames ? a?.paxNames : "").localeCompare(b?.paxNames ? b?.paxNames : ""))
    }

    setMyFiles(newData)
  }

  const sortByAgentName =(status)=>{
    let newData
    if(status){
      newData = myFiles && myFiles.sort((a, b) => (b.agentName).localeCompare(a.agentName))
    } else{
      newData = myFiles && myFiles.sort((a, b) => (a.agentName).localeCompare(b.agentName))
    }
    setMyFiles(newData)
  }

  const sortByDestination =(status)=>{
    let newData
    if(status){
      newData = myFiles && myFiles.sort((a, b) => (b.bookingDetails && b.bookingDetails.segments && b.bookingDetails.segments.length > 0 && b.bookingDetails.segments[0].destination?b.bookingDetails.segments[0].destination:"").localeCompare(a.bookingDetails && a.bookingDetails.segments && a.bookingDetails.segments.length > 0 && a.bookingDetails.segments[0].destination?a.bookingDetails.segments[0].destination:""))
    } else{
      newData = myFiles && myFiles.sort((a, b) => (a.bookingDetails && a.bookingDetails.segments && a.bookingDetails.segments.length > 0 && a.bookingDetails.segments[0].destination?a.bookingDetails.segments[0].destination:"").localeCompare(b.bookingDetails && b.bookingDetails.segments && b.bookingDetails.segments.length > 0 && b.bookingDetails.segments[0].destination?b.bookingDetails.segments[0].destination:""))
    }

    setMyFiles(newData)
  }

  const sortByPnr =(status)=>{
    let newData
    if (status) {
      newData = myFiles && myFiles.sort((a, b) => (b?.pnr ? b.pnr : "").localeCompare(a?.pnr ? a.pnr : ""))
    } else {
      newData = myFiles && myFiles.sort((a, b) => (a?.pnr ? a.pnr : "").localeCompare(b?.pnr ? b.pnr : ""))
    }

    setMyFiles(newData)
  }

  const sortByCarrier =(status)=>{
    let newData
    if(status){
      newData = myFiles && myFiles.sort((a, b) => (b && b.validatingCarrier ?b.validatingCarrier:"").localeCompare(a && a.validatingCarrier ?a.validatingCarrier:""))
    } else{
      newData = myFiles && myFiles.sort((a, b) => (a && a.validatingCarrier ?a.validatingCarrier:"").localeCompare(b && b.validatingCarrier ?b.validatingCarrier:""))
    }

    setMyFiles(newData)
  }

  useEffect(() => {
    props.setDisplayMyFiles(myFiles);
  }, [myFiles]);

  return (

    <>
    <div className=" pnrbooking">
        {props.filter === "sortBy" ?
          !customDateChanged ? 
            <Tabs defaultActiveKey="All" id="bookingpnrlist" activeKey={key}
              onSelect={getFilterByStatus}>
              {bookingStatusTabData && bookingStatusTabData.length > 0 && bookingStatusTabData.map((status) => {
                return (
                  <Tab eventKey={status.code} title={status.description}>
                    
                    <Allpnrbooking myFilesData={myFiles} activeKey="test" isResult={isResult} isLoading={isLoading}
                      sortData={(key  , status) => sortData(key, status)} isLoader={props.isLoading} applyFilters={(data)=>applyFilters(data)} from="sortBy" 
                      />
                  
                  </Tab>
                )
              })}

            </Tabs> 
          :
          <>
              <Allpnrbooking myFilesData={myFiles} activeKey="test" isResult={isResult} isLoading={isLoading}
                sortData={(key, status) => sortData(key, status)} isLoader={props.isLoading} applyFilters={(data)=>applyFilters(data)} from="sortBy" 
                />
          </>
          :
          <>
          <Allpnrbooking myFilesData={myFiles} isResult={isResult} isLoading={isLoading}
            sortData={(key, status) => sortData(key, status)} isLoader={props.isLoading} applyFilters={(data)=>applyFilters(data)} from="searchBy" 
            />
          </>
            }
        {!isLoading && isTimeoutErrorFlag && <p>Loading...</p>}
    </div>
    {!(isLoading || props.isLoading) && !isTimeoutErrorFlag && <div style={{"marginTop":"1rem"}}>
     <div className="d-flex justify-content-between">
        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <li className={nextResultKeyCounter == 0 ? "page-item disabled" : "page-item "}>
              <a className="page-link" tabIndex={-1}
                onClick={() => previousOnClick()}

              >
                Previous
              </a>
            </li>
          </ul>
        </nav>

        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <li className={endOfNextKey ? "page-item  disabled" : "page-item "}>
              <a
                className="page-link"
                onClick={() => nextOnClick()}
                tabIndex={-1}
              >
                Next

              </a>
            </li>
          </ul>
        </nav>
      </div>
      </div>}
    </>
  )
}
